import {Component, Inject, OnInit} from '@angular/core';
import {MeasureModel} from "../../model/measure.model";
import {DatapointModel} from "../../model/datapoint.model";
import {DeviceService} from "../device.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-datapoint-dialog',
    templateUrl: './datapoint-dialog.component.html',
    standalone: false
})
export class DatapointDialogComponent implements OnInit {
  item: DatapointModel;
  measures: MeasureModel[];

  constructor(
    private service: DeviceService,
    public dialogRef: MatDialogRef<DatapointDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.initDialog();
  }

  initDialog() {
    this.item = this.data.item;
    this.measures = this.data.measures;
  }

  onSaveClick() {
    if (!this.item.isValid()) {
      return this.service.notiService.open("Fill every required fields.");
    }
    this.service.saveDatapoint(this.item).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.service.notiService.open("Saved");
        this.dialogRef.close(new DatapointModel(resp));
      } else {
        this.service.notiService.open("Hiba a mentés közben.");
        console.log(resp);
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
